/**
 * Lighthouse Icon Component
 * 
 * Animated lighthouse with sweeping beam
 * The visual centerpiece of the chat widget
 */

import React from 'react';
import './LighthouseIcon.scss';

function LighthouseIcon({ isActive = false, size = 80 }) {
    return (
        <div
            className="lighthouse-icon"
            style={{ width: size, height: size }}
        >
            {/* Lighthouse structure */}
            <div className="lighthouse-tower">
                {/* Top (beacon room) */}
                <div className="lighthouse-top">
                    <div className="lighthouse-light"></div>
                </div>

                {/* Middle sections */}
                <div className="lighthouse-stripe"></div>
                <div className="lighthouse-body"></div>
                <div className="lighthouse-stripe"></div>

                {/* Base */}
                <div className="lighthouse-base"></div>
            </div>

            {/* Sweeping beam (only when active) */}
            {isActive && (
                <div className="lighthouse-beam-container">
                    <div className="lighthouse-beam"></div>
                </div>
            )}

            {/* Water ripples */}
            <div className="water-ripples">
                <div className="ripple ripple-1"></div>
                <div className="ripple ripple-2"></div>
                <div className="ripple ripple-3"></div>
            </div>
        </div>
    );
}

export default LighthouseIcon;
